import {
  TopSpecialFeaturesResponseItem,
  TopSpecialFeaturesItem
} from '@/types/TopSpecialFeatures'

export function convertTopSpecialFeaturesItem(
  response: TopSpecialFeaturesResponseItem
): TopSpecialFeaturesItem {
  return {
    guid: response.guid.rendered,
    title: response.acf.description,
    image: response.acf.image.url,
    url: response.acf.link_url,
    isPr: response.acf.is_pr
  }
}
